<template>
  <g>
    <path
      d="M6.36 18.7802L6.61 21.0002L8.23 19.4602L11 11.8602C10.32 11.6902 9.72 11.3502 9.23 10.8802L6.36 18.7802Z"
    />
    <path
      d="M14.77 10.8802C14.28 11.3502 13.67 11.6902 13 11.8602L15.77 19.4602L17.39 21.0002L17.65 18.7802L14.77 10.8802Z"
    />
    <path
      d="M14.94 8.60024C15.24 7.04024 14.34 5.66024 13 5.18024V4.00024C13 3.45024 12.55 3.00024 12 3.00024C11.45 3.00024 11 3.45024 11 4.00024V5.18024C9.84 5.60024 9 6.70024 9 8.00024C9 9.84024 10.66 11.3002 12.56 10.9502C13.74 10.7302 14.71 9.78024 14.94 8.60024ZM12 9.00024C11.45 9.00024 11 8.55024 11 8.00024C11 7.45024 11.45 7.00024 12 7.00024C12.55 7.00024 13 7.45024 13 8.00024C13 8.55024 12.55 9.00024 12 9.00024Z"
    />
  </g>
</template>
